import { gql } from '@/__generated__';

export const RepostCardFragment = gql(`
fragment RepostCardFragment on RePost {
  id
  createdAt
  originalPost {
    ...PostCardFragment
  }
  authorId
  author {
    id
    ...UserBadgeFragment
    following
    __typename
  }
  __typename
}
`);
